<template>
  <div>
    <v-simple-table fixed-header dense class="expediente-table">
      <thead>
        <tr class="grey lighten-4">
          <th class="text-center grey--text text--darken-2" width="50"></th>
          <th class="text-left grey--text text--darken-2 font-weight-bold">
            Documento
          </th>
          <th class="text-left grey--text text--darken-2 font-weight-bold" width="120">
            Referencia
          </th>
          <th class="text-left grey--text text--darken-2 font-weight-bold">
            Observaciones
          </th>
          <th class="text-center grey--text text--darken-2 font-weight-bold" width="70">
            Aplica
          </th>
          <th class="text-center grey--text text--darken-2 font-weight-bold" width="80">
            Compartir
          </th>
          <th class="text-center grey--text text--darken-2 font-weight-bold" width="100">
            Estado
          </th>
          <th class="text-center grey--text text--darken-2 font-weight-bold" width="100">
            Actualizado
          </th>
          <th class="text-center grey--text text--darken-2 font-weight-bold" width="120">
            Acciones
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="fila in filasAplanadas"
          :key="fila.key"
          v-show="fila.visible"
          :class="fila.clase">
          <!-- Fila de etapa -->
          <template v-if="fila.tipo === 'etapa'">
            <td colspan="9" class="grey lighten-3 py-3">
              <div class="d-flex align-center">
                <v-icon color="grey darken-2" class="mr-2">mdi-folder-open</v-icon>
                <span class="text-subtitle-1 grey--text text--darken-3 text-uppercase
                  font-weight-bold">
                  {{ fila.etapa }}
                </span>
                <v-chip small class="ml-3" color="grey darken-1" text-color="white">
                  {{ fila.totalDocumentos }} documentos
                </v-chip>
              </div>
            </td>
          </template>

          <!-- Fila de documento padre -->
          <template v-else-if="fila.tipo === 'documento'">
            <!-- Botón expandir hijos -->
            <td class="text-center px-0">
              <v-btn
                v-if="fila.tieneHijos"
                icon
                small
                @click="toggleHijos(fila.documento.id)">
                <v-icon :color="hijosExpandidos[fila.documento.id] ? 'primary' : 'grey'">
                  {{ hijosExpandidos[fila.documento.id]
                    ? 'mdi-chevron-down'
                    : 'mdi-chevron-right' }}
                </v-icon>
              </v-btn>
            </td>

            <!-- Descripción -->
            <td class="py-2">
              <div class="d-flex align-center">
                <v-icon
                  small
                  class="mr-2"
                  :color="fila.documento.publicKey ? 'red darken-1' : 'grey lighten-1'">
                  mdi-file-pdf-box
                </v-icon>
                <span class="font-weight-medium">
                  {{ fila.documento.documento.descripcion }}
                </span>
                <v-chip v-if="fila.tieneHijos" x-small class="ml-2" color="grey lighten-2">
                  +{{ fila.documento.childrens.length }}
                </v-chip>
              </div>
            </td>

            <!-- Referencia -->
            <td>
              <span class="text-caption grey--text text--darken-1">
                {{ fila.documento.referencia || '-' }}
              </span>
            </td>

            <!-- Observaciones -->
            <td>
              <v-tooltip v-if="fila.documento.observaciones" top max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-truncate d-inline-block"
                    style="max-width: 200px;">
                    {{ fila.documento.observaciones }}
                  </span>
                </template>
                <span>{{ fila.documento.observaciones }}</span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </td>

            <!-- Switch Aplica -->
            <td class="text-center">
              <switch-aplica :expedienteDocumentoEditar="fila.documento" />
            </td>

            <!-- Switch Compartir -->
            <td class="text-center">
              <switch-compartir :expedienteDocumentoEditar="fila.documento" />
            </td>

            <!-- Estado del documento -->
            <td class="text-center">
              <v-chip
                v-if="fila.documento.publicKey"
                small
                color="success"
                text-color="white">
                <v-icon left x-small>mdi-check</v-icon>
                Integrado
              </v-chip>
              <v-chip
                v-else-if="fila.documento.aplica"
                small
                color="warning"
                text-color="white">
                <v-icon left x-small>mdi-alert</v-icon>
                Pendiente
              </v-chip>
              <v-chip v-else small color="grey lighten-2" text-color="grey darken-1">
                No aplica
              </v-chip>
            </td>

            <!-- Fecha actualización -->
            <td class="text-center">
              <fecha-humano :fecha="new Date(fila.documento.updatedAt)" />
            </td>

            <!-- Acciones -->
            <td class="text-center">
              <div class="d-flex justify-center">
                <v-tooltip v-if="fila.documento.publicKey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="verDocumentoExpediente(fila.documento)">
                      <v-icon small color="primary">mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver PDF</span>
                </v-tooltip>

                <v-tooltip v-if="fila.documento.publicKey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="descargarDocumentoExpediente(fila.documento)">
                      <v-icon small color="blue darken-1">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="editarDocumentoExpediente(fila.documento)">
                      <v-icon
                        small
                        :color="fila.documento.publicKey ? 'warning' : 'success'">
                        {{ fila.documento.publicKey ? 'mdi-pencil' : 'mdi-plus-circle' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ fila.documento.publicKey ? 'Editar' : 'Agregar PDF' }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="borrarDocumentoExpediente(fila.documento)">
                      <v-icon small color="error">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </div>
            </td>
          </template>

          <!-- Fila de documento hijo -->
          <template v-else-if="fila.tipo === 'hijo'">
            <td class="text-center">
              <v-icon x-small color="grey lighten-1">mdi-subdirectory-arrow-right</v-icon>
            </td>

            <td class="py-2">
              <div class="d-flex align-center pl-4">
                <v-icon
                  small
                  class="mr-2"
                  :color="fila.documento.publicKey ? 'red darken-1' : 'grey lighten-1'">
                  mdi-file-pdf-box
                </v-icon>
                <span>{{ fila.documento.documento.descripcion }}</span>
              </div>
            </td>

            <td>
              <span class="text-caption grey--text text--darken-1">
                {{ fila.documento.referencia || '-' }}
              </span>
            </td>

            <td>
              <v-tooltip v-if="fila.documento.observaciones" top max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-truncate d-inline-block"
                    style="max-width: 200px;">
                    {{ fila.documento.observaciones }}
                  </span>
                </template>
                <span>{{ fila.documento.observaciones }}</span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </td>

            <td class="text-center">
              <switch-aplica :expedienteDocumentoEditar="fila.documento" />
            </td>

            <td class="text-center">
              <switch-compartir :expedienteDocumentoEditar="fila.documento" />
            </td>

            <td class="text-center">
              <v-chip
                v-if="fila.documento.publicKey"
                x-small
                color="success"
                text-color="white">
                Integrado
              </v-chip>
              <v-chip
                v-else-if="fila.documento.aplica"
                x-small
                color="warning"
                text-color="white">
                Pendiente
              </v-chip>
              <v-chip v-else x-small color="grey lighten-2" text-color="grey darken-1">
                No aplica
              </v-chip>
            </td>

            <td class="text-center">
              <fecha-humano :fecha="new Date(fila.documento.updatedAt)" />
            </td>

            <td class="text-center">
              <div class="d-flex justify-center">
                <v-tooltip v-if="fila.documento.publicKey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      @click="verDocumentoExpediente(fila.documento)">
                      <v-icon x-small color="primary">mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver PDF</span>
                </v-tooltip>

                <v-tooltip v-if="fila.documento.publicKey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      @click="descargarDocumentoExpediente(fila.documento)">
                      <v-icon x-small color="blue darken-1">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      @click="editarDocumentoExpediente(fila.documento)">
                      <v-icon
                        x-small
                        :color="fila.documento.publicKey ? 'warning' : 'success'">
                        {{ fila.documento.publicKey ? 'mdi-pencil' : 'mdi-plus-circle' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ fila.documento.publicKey ? 'Editar' : 'Agregar PDF' }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      @click="borrarDocumentoExpediente(fila.documento)">
                      <v-icon x-small color="error">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </div>
            </td>
          </template>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- Dialog de descarga -->
    <v-dialog
      v-model="mostrarDescargando"
      width="280"
      persistent>
      <v-card>
        <v-card-title class="grey darken-3 white--text py-3">
          <v-icon color="white" class="mr-2">mdi-download</v-icon>
          Descargando archivo
        </v-card-title>
        <v-card-text class="pt-6 pb-4">
          <div class="text-center">
            <v-progress-circular
              :size="80"
              :width="8"
              :value="progresoDescarga || 0"
              color="primary">
              <span class="text-h6">{{ progresoDescarga || 0 }}%</span>
            </v-progress-circular>
            <p class="mt-4 mb-0 grey--text">
              Por favor espere...
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import SwitchAplica from '@/components/administracion/expedientes/documentos/SwitchAplica.vue';
import SwitchCompartir from '@/components/administracion/expedientes/documentos/SwitchCompartir.vue';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoDocumentosExpedienteDesktop',
  mixins: [mixDescargarArchivo],
  props: {
    listadoDocumentosExpedienteContrato: {
      type: Array,
      required: true,
    },
  },
  components: {
    SwitchAplica,
    SwitchCompartir,
    FechaHumano,
  },
  data() {
    return {
      mostrarDescargando: false,
      progresoDescarga: null,
      hijosExpandidos: {},
    };
  },
  computed: {
    filasAplanadas() {
      const filas = [];

      this.listadoDocumentosExpedienteContrato.forEach((item) => {
        if (item.documentos.length === 0) return;

        // Agregar fila de etapa
        filas.push({
          key: `etapa-${item.etapa}`,
          tipo: 'etapa',
          etapa: item.etapa,
          totalDocumentos: item.documentos.length,
          visible: true,
          clase: 'etapa-header',
        });

        // Agregar documentos y sus hijos
        item.documentos.forEach((documento) => {
          // Documento padre
          filas.push({
            key: `doc-${documento.id}`,
            tipo: 'documento',
            documento,
            tieneHijos: documento.childrens && documento.childrens.length > 0,
            visible: true,
            clase: {
              'documento-row': true,
              faltante: documento.aplica && !documento.publicKey,
              integrado: !!documento.publicKey,
            },
          });

          // Documentos hijos
          if (documento.childrens && documento.childrens.length > 0) {
            documento.childrens.forEach((hijo) => {
              filas.push({
                key: `hijo-${hijo.id}`,
                tipo: 'hijo',
                documento: hijo,
                padreId: documento.id,
                visible: !!this.hijosExpandidos[documento.id],
                clase: {
                  'documento-hijo': true,
                  faltante: hijo.aplica && !hijo.publicKey,
                  integrado: !!hijo.publicKey,
                },
              });
            });
          }
        });
      });

      return filas;
    },
  },
  methods: {
    toggleHijos(documentoId) {
      this.$set(this.hijosExpandidos, documentoId, !this.hijosExpandidos[documentoId]);
    },
    editarDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('editar-documento-expediente', documentoExpediente);
    },
    borrarDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('borrar-documento-expediente', documentoExpediente);
    },
    verDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('ver-documento-expediente', documentoExpediente);
    },
    descargarDocumentoExpediente(documentoExpediente) {
      const documento = documentoExpediente;
      const etapa = this.setEtapa(documentoExpediente.documento.etapa);
      documento.etapa = etapa;
      this.mixDescargarArchivo(documentoExpediente, 'expedientes');
    },
    setEtapa(etapa) {
      if (etapa === 1) return 'AE';
      if (etapa === 2) return 'EJ';
      if (etapa === 3) return 'DE';
      return 'N/A';
    },
  },
};
</script>

<style lang="scss" scoped>
.expediente-table {
  .etapa-header td {
    border-bottom: none !important;
  }

  .documento-row {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f5f5f5 !important;
    }

    &.faltante {
      border-left: 3px solid #ff9800;
    }

    &.integrado {
      border-left: 3px solid #4caf50;
    }
  }

  .documento-hijo {
    background-color: #fafafa;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f0f0f0 !important;
    }

    &.faltante {
      border-left: 3px solid #ff9800;
    }

    &.integrado {
      border-left: 3px solid #4caf50;
    }
  }
}
</style>
